import styled, { css } from 'styled-components';

export const DialogTitle = styled('h1')(
  ({ theme }) => css`
    ${theme.typography.h1};
    color: ${theme.palette.secondary[900]};
    text-align: center;
  `,
);
